/*
 * @Desc: 路由列表
 * @Author: simbawu
 * @Date: 2019-07-23 17:38:51
 * @LastEditors: jiayi zhu
 */
export default [
  {
    path: '/',
    page: 'index'
  },
  {
    path: '/error',
    page: 'error',
    name: '错误页'
  },
  {
    path: '/forms/:activity',
    page: 'forms/'
  },
  {
    path: '/leke/fetch-easy-vip',
    page: 'leke/fetch-easy-vip'
  },
  {
    path: '/leke/user-status',
    page: 'leke/user-status'
  },
  {
    path: '/health_task',
    page: 'health-task',
    name: '活动/上秤吧有钱'
  },
  {
    path: '/health_task/:id/progress',
    page: 'health-task/progress'
  },
  {
    path: '/health_task/:id/recevied_reward',
    page: 'health-task/recevied-reward'
  },
  {
    path: '/exercise_check/:id',
    page: 'exercise-check'
  },
  {
    path: '/exercise_check/:id/report',
    page: 'exercise-check/report'
  },
  {
    path: '/exercise_check/:id/submit',
    page: 'exercise-check/submit'
  },
  {
    path: '/exercise_check/:id/exercise_calendar',
    page: 'exercise-check/exercise-calendar'
  },
  {
    path: '/exercise_check/:id/exercise_calendar/details/:date',
    page: 'exercise-check'
  },
  {
    path: '/exercise_check/:id/user',
    page: 'exercise-check/user'
  },
  {
    path: '/exercise_check/:id/user/edit',
    page: 'exercise-check/edit-user-info'
  },
  {
    path: '/:provider/exercise_check/:id',
    page: 'exercise-check'
  },
  {
    path: '/:provider/exercise_check/:id/submit',
    page: 'exercise-check/submit'
  },
  {
    path: '/nice_audio/:course_id',
    page: 'nice-audio'
  },
  {
    path: '/nice_audio/:course_id/items/:items_id',
    page: 'nice-audio/course'
  },
  {
    path: '/promotion',
    page: 'promotion',
    name: '商店促销'
  },

  {
    path: '/rectify/transition',
    page: 'rectify/transition'
  },
  {
    path: '/rectify/evaluation/photograph',
    page: 'rectify/evaluation/photograph',
    name: '腿形矫正提交照片'
  },
  {
    path: '/rectify/evaluation/question',
    page: 'rectify/evaluation/question',
    name: '腿形矫正测评题'
  },
  {
    path: '/rectify/service/activate/:state',
    page: 'rectify/service/activate'
  },
  {
    path: '/rectify/service/day/:seq',
    page: 'rectify/service'
  },
  {
    path: '/rectify/service/end',
    page: 'rectify/service/end'
  },
  {
    path: '/rectify/service/record',
    page: 'rectify/service/record'
  },
  {
    path: '/rectify/service/photograph',
    page: 'rectify/service/photograph'
  },
  {
    path: '/rectify/service/uploadPhotos/:nth_week',
    page: 'rectify/evaluation/photograph'
  },
  {
    path: '/diets',
    page: 'diets'
  },
  {
    path: '/nice_survey',
    page: 'survey/survey-pro',
    name: 'nice合约测评'
  },
  {
    path: '/nice/exchange_code',
    page: 'nice/exchange',
    name: 'nice激活'
  },
  {
    path: '/nice/ranking',
    page: 'nice/rank',
    name: 'nice减重排名'
  },
  {
    path: '/nice_surveypro',
    page: 'survey',
    name: 'nicePro合约测评'
  },
  {
    path: '/nice/message',
    page: 'nice/message',
    name: 'nice发送消息页面'
  },
  {
    path: '/nice/recipe',
    page: 'nice/recipe',
    name: 'nice食谱计划页'
  },
  {
    path: '/nice/exercise',
    page: 'nice/daily-exercise',
    name: 'nice运动计划页'
  },
  {
    path: '/lottery',
    page: 'lottery',
    name: '幸运九宫格抽奖页'
  },
  {
    path: '/lottery-super',
    page: 'lottery-super',
    name: '超级动态九宫格'
  },
  {
    path: '/nice/bind_wechat',
    page: 'nice/bind-weChat',
    name: 'nice绑定微信提示页'
  },
  {
    path: '/nice/add_wechat',
    page: 'nice/add-weChat',
    name: 'nice添加微信页'
  },
  {
    path: '/nice/signup/:id',
    page: 'sign-up/index'
  },
  {
    path: '/nice/collections/:id/apply',
    page: 'sign-up/order-details'
  },
  {
    path: '/nice/addMes/:id',
    page: 'sign-up/add-mes'
  },
  {
    path: '/nice/has_bought/:id',
    page: 'group-guide/check-bought'
  },
  {
    path: '/nice/app_group/:id',
    page: 'group-guide/app-group'
  },
  {
    path: '/nice/collections/:id',
    page: 'group-guide/wechat-group'
  },
  {
    path: '/rookie_discount',
    page: 'rookie/',
    name: '商店小程序新人领红包页'
  },
  {
    path: '/nice/introduce/:id',
    page: 'sign-up/introduce'
  },
  {
    path: '/nice/share/:id',
    page: 'sign-up/share'
  },
  {
    path: '/nice/plan/recipe',
    page: 'nice-plan/recipe-plan',
    name: 'nice食谱计划'
  },
  {
    path: '/nice/plan/sport',
    page: 'nice-plan/sport-plan',
    name: 'nice运动计划'
  },
  {
    path: '/wisdom/exchange',
    page: 'wisdom/',
    name: '激活智慧营养师'
  },
  {
    path: '/report/data',
    page: 'report/report',
    name: '2018年度减肥报告'
  },
  {
    path: '/report/cover',
    page: 'report/cover'
  },
  {
    path: '/report/shake',
    page: 'report/shake'
  },
  {
    path: '/report/sticker',
    page: 'report/sticker'
  },
  {
    path: '/app/logout',
    page: 'logout/',
    name: 'app注销账号入口'
  },
  {
    path: '/app/logout/process',
    page: 'logout/logout-process/'
  },
  {
    path: '/app/logout/reason',
    page: 'logout/logout-reason/'
  },
  {
    path: '/app/shop/modify-address',
    page: 'app-shop/modify-address',
    name: 'app商店修改地址页'
  },
  {
    path: '/app/shop/new-custom',
    page: 'app-shop/new-custom',
    name: 'app商店新客促销页'
  },
  {
    path: '/app/shop/hot',
    page: 'app-shop/hot',
    name: 'app商店热榜'
  },
  {
    path: '/app/healthReport',
    page: 'health-report/v1',
    name: '健康报告V1.0'
  },
  {
    path: '/app/healthReport/new',
    page: 'health-report/v2',
    name: '健康报告V2.0'
  },
  {
    path: '/app/healthReport/v3',
    page: 'health-report/v3',
    name: '健康报告V3.0'
  },
  {
    path: '/nice/confirm-order/:id',
    page: 'sign-up/confirm-order'
  },
  {
    path: '/nice/bought-notice',
    page: 'sign-up/bought-notice',
    name: 'nice商品购买完成提示页'
  },
  {
    path: '/cooperation/haluo/:step',
    page: 'cooperation/haluo'
  },
  {
    path: '/app/live',
    page: 'app-live',
    name: 'app直播分享页'
  },
  {
    path: '/cooperation/eleme/receive',
    page: 'cooperation/eleme/',
    name: '饿了么合作页'
  },
  {
    path: '/cooperation/meiyan',
    page: 'cooperation/meiyan/',
    name: '美颜相机合作页'
  },
  {
    path: '/app/shop/reduce',
    page: 'shop-reduction/',
    name: '商店满减活动页'
  },
  {
    path: '/cooperation/ximalaya/receive',
    page: 'cooperation/ximalaya/',
    name: '喜马拉雅合作页'
  },
  {
    path: '/gensci/survey',
    page: 'gensci/survey',
    name: '金赛药业测评题页面'
  },
  {
    path: '/gensci/meal',
    page: 'gensci/meal'
  },
  {
    path: '/gensci/nutrition',
    page: 'gensci/nutrition'
  },
  {
    path: '/gensci/recipe-list',
    page: 'gensci/recipe-list'
  },
  {
    path: '/gensci/user-eating-habits',
    page: 'gensci/user-eating-habits'
  },
  {
    path: '/gensci/allergy',
    page: 'gensci/allergy'
  },
  {
    path: '/gensci/recipe-detail',
    page: 'gensci/recipe-detail'
  },
  {
    path: '/gensci/recipe-replace',
    page: 'gensci/recipe-replace'
  },
  {
    path: '/gensci/analysis',
    page: 'gensci/analysis'
  },
  {
    path: '/weight',
    page: 'weight',
    name: '体重记录'
  },
  {
    path: '/nps',
    page: 'nps/index',
    name: 'nps'
  },
  {
    path: '/nps/end',
    page: 'nps/end'
  },
  {
    path: '/app/shop/reduce',
    page: 'shop-reduction/'
  },
  {
    path: '/messenger',
    page: 'messenger/',
    name: '客服咨询系统消息列表'
  },
  {
    path: '/messenger/post-messenger',
    page: 'messenger/post-messenger'
  },
  {
    path: '/easy/index',
    page: 'easy/',
    name: 'app——easy会员首页'
  },
  {
    path: '/easy/introduce',
    page: 'easy/introduce',
    name: 'app——easy会员购买入口'
  },
  {
    path: '/easy/success/:step',
    page: 'easy/success'
  },
  {
    path: '/easy/recipe/introduce',
    page: 'easy/recipe-introduce',
    name: 'app——easy会员免费食谱介绍页'
  },
  {
    path: '/easy/equity/coupons',
    page: 'easy/coupons',
    name: 'app——easy会员红包权益领取'
  },
  {
    path: '/easy/equity/snacks',
    page: 'easy/snacks',
    name: 'app——easy会员零食权益领取'
  },
  {
    path: '/easy/get/equity',
    page: 'easy/get-equity',
    name: 'app——获取会员激活权益'
  },
  {
    path: '/free-recipe',
    page: 'free-recipe',
    name: '免费食谱'
  },
  {
    path: '/easy/get/scale',
    page: 'easy/get-scale',
    name: '会员领取体脂秤赠品'
  },
  {
    path: '/subscribe/list/:state',
    page: 'subscribe',
    name: '订阅列表'
  },
  {
    path: '/subscribe/sku',
    page: 'subscribe/choose-sku',
    name: '订阅sku选择'
  },
  {
    path: '/subscribe/detail',
    page: 'subscribe/detail',
    name: '订阅详情'
  },
  {
    path: '/app-shop/customize/list/:state',
    page: 'app-shop/customize',
    name: '定制列表'
  },
  {
    path: '/app-shop/customize/detail',
    page: 'app-shop/customize/detail',
    name: '定制详情'
  },
  {
    path: '/app-shop/customize/report',
    page: 'app-shop/customize/report',
    name: '定制测评报告'
  },
  {
    path: '/app-shop/customize/scheme',
    page: 'app-shop/customize/scheme',
    name: '定制方案'
  },
  {
    path: '/app-shop/customize/order',
    page: 'app-shop/customize/order',
    name: '定制方案下单页面'
  },
  {
    path: '/tools/weight-record',
    page: 'tools/weight-record',
    name: '体重记录工具页'
  },
  {
    path: '/test',
    page: 'test'
  },
  {
    path: '/gene',
    page: 'gene',
    name: '基因检测首页'
  },
  {
    path: '/gene/gene-bind',
    page: 'gene/gene-bind',
    name: '基因绑定页'
  },
  {
    path: '/gene/scan-success',
    page: 'gene/scan-success',
    name: '扫码成功页'
  },
  {
    path: '/gene/info-confirm/:code',
    page: 'gene/info-confirm',
    name: '信息确认页'
  },
  {
    path: '/gene/informed-consent/:code',
    page: 'gene/informed-consent',
    name: '知情同意书页'
  },
  {
    path: '/gene/bind-success/:code',
    page: 'gene/bind-success',
    name: '绑定成功页'
  },
  {
    path: '/gene/info-completion/:code',
    page: 'gene/info-completion',
    name: '回寄信息填写页'
  },
  {
    path: '/gene/appointment-confirm/:code',
    page: 'gene/appointment-confirm',
    name: '确认预约页'
  },
  {
    path: '/gene/appointment-success',
    page: 'gene/appointment-success',
    name: '预约成功页'
  },
  {
    path: '/gene/sample-state/:state',
    page: 'gene/sample-state',
    name: '样本状态查询页'
  },
  {
    path: '/gene/report-list',
    page: 'gene/report-list',
    name: '检测报告首页'
  },
  {
    path: '/gene/second-list/:id',
    page: 'gene/second-list',
    name: '检测报告二级页'
  },
  {
    path: '/gene/report-result/:id',
    page: 'gene/report-result',
    name: '检测报告结果页'
  },
  {
    path: '/gene/test-fail',
    page: 'gene/test-fail',
    name: '检测失败页'
  },
  {
    path: '/gene/gene-level',
    page: 'gene/gene-level'
  },
  {
    path: '/gene/report-search',
    page: 'gene/report-search',
    name: '基因搜索'
  },
  {
    path: '/add/adviser',
    page: 'add-adviser',
    name: '添加顾问页面'
  },
  {
    path: '/poo/add',
    page: 'poo/add'
  },
  {
    path: '/poo/update',
    page: 'poo/update'
  },
  {
    path: '/poo/analysis',
    page: 'poo/analysis'
  },
  {
    path: '/easy/equlity/list',
    page: 'easy/equlity-list',
    name: '会员权益明细'
  },
  {
    path: '/invite/introduce',
    page: 'invite',
    name: '邀请新人'
  },
  {
    path: '/gene/focus',
    page: 'focus',
    name: '我的关注'
  },
  {
    path: '/gene/bound-samples',
    page: 'bound-samples',
    name: '基因检测'
  },
  {
    path: '/gene/sample-reports',
    page: 'sample-reports',
    name: '示例报告'
  },
  {
    path: '/gene/link-report',
    page: 'link-report',
    name: '关联基因采样'
  },
  {
    path: '/qy-wechat/message',
    page: 'qy-wechat',
    name: '企业微信个人信息页'
  },
  {
    path: '/qy-wechat/coupon',
    page: 'qy-wechat/coupon',
    name: '企业微信发送红包页面'
  },
  {
    path: '/qy-wechat/goods',
    page: 'qy-wechat/goods',
    name: '企业微信发送商品套餐页面'
  },
  {
    path: '/qy-wechat/custom-list',
    page: 'qy-wechat/custom-list',
    name: '企业微信客户信息列表'
  },
  {
    path: '/qy-wechat/express-record',
    page: 'qy-wechat/express-record',
    name: '企业微信订单物流'
  },
  {
    path: '/qy-wechat/follow-up',
    page: 'qy-wechat/follow-up',
    name: '企业微信客户跟进记录'
  },
  {
    path: '/qy-wechat/follow-list',
    page: 'qy-wechat/follow-list',
    name: '企业微信客户跟进记录'
  },
  {
    path: '/qy-wechat/questionnaire',
    page: 'qy-wechat/questionnaire',
    name: '企业微信客户问卷'
  },
  {
    path: '/qy-wechat/questionnaires_diabetes',
    page: 'qy-wechat/questionnaires_diabetes',
    name: '糖尿病用户调查问卷'
  },
  {
    path: '/qy-wechat/questionnaire_auth',
    page: 'qy-wechat/questionnaire_auth',
    name: '问卷调查'
  },
  {
    path: '/qy-wechat/gpt',
    page: 'qy-wechat/gpt',
    name: 'AI对话'
  },
  {
    path: '/qy-wechat/questionnaires_weight_mng',
    page: 'qy-wechat/questionnaires_weight_mng',
    name: '体重管理用户调查问卷'
  },
  {
    path: '/qy-wechat/behavior-list',
    page: 'qy-wechat/behavior-list',
    name: '企业微信关键行为列表'
  },
  {
    path: '/qy-wechat/moment',
    page: 'qy-wechat/moment',
    name: '企业微信朋友圈'
  },
  {
    path: '/qy-wechat/cart',
    page: 'qy-wechat/cart',
    name: '企业微信用户购物车'
  },
  {
    path: '/qy-wechat/return-visit',
    page: 'qy-wechat/return-visit',
    name: '企业微信用户回访记录'
  },
  {
    path: '/qy-wechat/survey',
    page: 'qy-wechat/survey',
    name: '企业微信健康测评'
  },
  {
    path: '/qy-wechat/survey/result',
    page: 'qy-wechat/survey/result',
    name: '企业微信健康测评结果'
  },
  {
    path: '/qy-wechat/order',
    page: 'qy-wechat/order',
    name: '企业微信EKA订单'
  },
  {
    path: '/qy-wechat/user_state',
    page: 'qy-wechat/user_state',
    name: '全餐顾客回访'
  },
  {
    path: '/qy-wechat/task_create',
    page: 'qy-wechat/task_create',
    name: '创建工单'
  },
  {
    path: '/qy-wechat/redirect/:sub',
    page: 'qy-wechat/redirect',
    name: '跳转页'
  },
  {
    path: '/health-record/after-full-meal',
    page: 'health-record/after-full-meal',
    name: '荣誉证书'
  },
  {
    path: '/equlity/gift/choose',
    page: 'easy/equlity-gift-choose',
    name: '选择权益赠品'
  },
  {
    path: '/faq',
    page: 'faq',
    name: '常见问题'
  },
  {
    path: '/app/shop/rank',
    page: 'app-shop/rank',
    name: '商店购物排行榜'
  },
  {
    path: '/share-coupon/list',
    page: 'share-coupon/',
    name: '助力分享领券'
  },
  {
    path: '/share-coupon/share',
    page: 'share-coupon/share',
    name: '助力分享领券详情页'
  },
  {
    path: '/invoice/order',
    page: 'app-shop/invoice/order-list',
    name: '选择订单开票页'
  },
  {
    path: '/invoice/record',
    page: 'app-shop/invoice/record',
    name: '开票记录'
  },
  {
    path: '/invoice/detail',
    page: 'app-shop/invoice/detail',
    name: '发票详情'
  },
  {
    path: '/invoice/edit',
    page: 'app-shop/invoice/edit',
    name: '填写发票详情'
  },
  {
    path: '/invoice/company-mes',
    page: 'app-shop/invoice/company-mes',
    name: '更多企业信息'
  },
  {
    path: '/achievement',
    page: 'achievement/',
    name: '成就系统个人首页'
  },
  {
    path: '/achievement/share',
    page: 'achievement/share',
    name: '分享成就'
  },
  {
    path: '/achievement/detail',
    page: 'achievement/detail',
    name: '成就详情'
  },
  {
    path: '/share-page',
    page: 'share-page'
  },
  {
    path: '/app-shop/refer',
    page: 'app-shop/refer',
    name: '种草宣传页'
  },
  {
    path: '/app-shop/follow',
    page: 'app-shop/follow',
    name: '商店关注专区'
  },
  {
    path: '/app-shop/choose',
    page: 'app-shop/choose',
    name: '商店n+m自选页'
  },
  {
    path: '/app/welfare',
    page: 'welfare',
    name: '新人福利专区'
  },
  {
    path: '/cooperation/receive',
    page: 'cooperation/common/',
    name: '抖音合作页'
  }
];
